<template>
  <!-- rf04_1 , rf04_2 -->
  <v-content class="pa-12">
    <v-layout style="background-color: #FAF5F2;">
      <v-flex>
        <v-flex shrink style="text-align: right"><v-btn dark @click="printPage()"
            style="width: 80px; background-color: black;"><v-icon>local_printshop</v-icon></v-btn></v-flex>
        <v-layout mb-4>
          <v-flex style="font-size: 28px;font-weight: bold;color: #737373">
            <span>แบบฟอร์ม</span>
          </v-flex>
        </v-layout>

        <div id="print" style="height: auto">
          <div class="print-form">
            <v-layout mx-6>
              <v-flex>
                <v-layout style="background-color: #3E7662;">
                  <v-flex my-4 ml-8 style="text-align: left;font-size: 28px;color: white">
                    <div style="font-weight: bold">
                      แบบประเมินรายงานเหตุการณ์ไม่พึงประสงค์ชนิดร้ายแรง
                    </div>
                    <div style="font-size: 18px;">
                      Assessment Form of Internal Serious Adverse Events
                    </div>
                  </v-flex>
                  <v-flex ml-8 pt-8 pr-8 style="text-align: right;font-weight: bold;font-size: 13px;color: white">
                    <span>RO 07_2563</span>
                  </v-flex>
                </v-layout>

                <!-- Start Form -->

                <!-- Card 1 -->
                <v-card class="mb-12">
                  <!-- Form Input -->
                  <v-layout pa-12 class="justify-center">
                    <v-flex xs10>
                      <!-- row 1 -->
                      <v-layout mb-8 mt-12>
                        <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                          <b>รหัสโครงร่างการวิจัย</b>
                        </v-flex>
                        <v-flex xs4 class="text-start">
                          <TextfieldForm readonly :model="form.researchCode" hide-detail
                            @update-data="updateData('researchCode', $event)" />
                        </v-flex>
                        <v-spacer></v-spacer>
                      </v-layout>
                      <!-- row 2 -->
                      <v-layout mb-8>
                        <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                          <b>ชื่อผู้วิจัยหลัก</b>
                        </v-flex>
                        <v-flex xs4 class="text-start">
                          <TextfieldForm readonly :model="form.firstName" hide-detail
                            @update-data="updateData('firstName', $event)" />
                        </v-flex>
                        <v-flex mx-4 xs1 class="d-flex justify-end align-center">
                          <b>นามสกุล</b>
                        </v-flex>
                        <v-flex>
                          <TextfieldForm readonly :model="form.lastName" hide-detail
                            @update-data="updateData('lastName', $event)" />
                        </v-flex>
                      </v-layout>
                      <!-- row 3 -->
                      <v-layout mb-8>
                        <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                          <b>ชื่อโครงการวิจัย (ไทย)</b>
                        </v-flex>
                        <v-flex>
                          <textarea-form hide-detail :model="form.researchName"
                            @update-data="updateData('researchName', $event)"></textarea-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 4 -->
                      <v-layout mb-8>
                        <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                          <b>Sponsor</b>
                        </v-flex>
                        <v-flex>
                          <TextfieldForm :readonly="$route.query.read == 1" :model="form.Sponsor" hide-detail
                            @update-data="updateData('Sponsor', $event)" />
                        </v-flex>
                      </v-layout>
                      <!-- row 5 -->
                      <v-layout mb-8>
                        <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                          <b>Medicinal product/ s and/or device</b>
                        </v-flex>
                        <v-flex>
                          <TextfieldForm :readonly="$route.query.read == 1" :model="form.medicinalProduct" hide-detail
                            @update-data="updateData('medicinalProduct', $event)" />
                        </v-flex>
                      </v-layout>
                      <!-- row 6 -->
                      <v-layout mb-8>
                        <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                          <b>Adverse Event</b>
                        </v-flex>
                        <v-flex>
                          <TextfieldForm :readonly="$route.query.read == 1" :model="form.adverseEvent" hide-detail
                            @update-data="updateData('adverseEvent', $event)" />
                        </v-flex>
                      </v-layout>
                      <!-- row 7 -->
                      <v-layout>
                        <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                          <b>Onset of SAE</b>
                        </v-flex>
                        <v-flex xs3 class="text-start">
                          <TextfieldForm readonly v-if="$route.query.read == 1" hide-detail :model="dateChange1" />
                          <DateInputForm v-else hide-detail :model="dateChange1"
                            @update-data="updateDate('SAEDate', $event)" />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <!-- Form Check Radio -->
                  <v-layout style="padding-right: 100px;padding-left: 100px;margin-top: 100px;padding-bottom: 50px">
                    <v-flex>
                      <!-- Event reported -->
                      <v-layout>
                        <v-flex class="text-start font-weight-bold">
                          <span>Event reported</span>
                        </v-flex>
                      </v-layout>
                      <v-layout class="ml-6 mt-4">
                        <v-flex>
                          <v-radio-group v-model="form.eventReport" row :readonly="$route.query.read == 1">
                            <v-radio color="#3E7662" style="padding-right: 50px" label="Initial report"
                              value="1"></v-radio>
                            <v-radio color="#3E7662" style="padding-right: 50px" label="Follow-up repor"
                              value="2"></v-radio>
                            <v-radio color="#3E7662" label="Final report" value="3"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>

                      <v-layout>
                        <v-flex shrink class="d-flex align-center font-weight-bold mr-4">
                          <span>วันที่ผู้วิจัยรับทราบ</span>
                        </v-flex>
                        <v-flex shrink>
                          <DateInputForm hide-detail :model="dateEventReport"
                            @update-data="updateDate('dateEventReport', $event)" />
                        </v-flex>
                      </v-layout>

                      <!-- Severity of event-->
                      <v-layout style="margin-top: 100px;">
                        <v-flex class="text-start font-weight-bold">
                          <span>Severity of event</span>
                        </v-flex>
                      </v-layout>
                      <div class="pl-4 py-1 text-start font-weight-bold">
                        - กรณีที่ 1 และ 2 แจ้ง IRB ภายใน 24 ชม.
                      </div>
                      <div class="pl-4 py-1 text-start font-weight-bold">
                        - กรณีที่ 3-5 แจ้ง IRB ภายใน 2 วันปฏิทิน
                      </div>
                      <v-layout class="ml-6 mt-4">
                        <v-flex>
                          <v-radio-group v-model="form.eventSeverity" :readonly="$route.query.read == 1">
                            <v-radio class="mb-6" color="#3E7662" label="1. Death" value="1"></v-radio>
                            <v-radio class="mb-6" color="#3E7662" label="2. Life theatening" value="2"></v-radio>
                            <v-radio class="mb-6" color="#3E7662" label="3. Hospitalization / prolanged hospitalization"
                              value="3"></v-radio>
                            <v-radio class="mb-6" color="#3E7662"
                              label="4. Persistent or significant disability / incapacity" value="4"></v-radio>
                            <v-radio class="mb-6" color="#3E7662" label="5. Congenital anomaly / birth defect"
                              value="5"></v-radio>
                            <v-radio color="#3E7662" label="6. Not serious" value="6"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>

                      <!-- Causality of event-->
                      <v-layout style="margin-top: 100px;">
                        <v-flex class="text-start font-weight-bold">
                          <span>Causality of event</span>
                        </v-flex>
                      </v-layout>
                      <v-layout class="ml-6 mt-4">
                        <v-flex>
                          <v-radio-group v-model="form.eventCausality" :readonly="$route.query.read == 1">
                            <v-radio class="mb-6" color="#3E7662" label="1. Not related" value="1"></v-radio>
                            <v-radio class="mb-6" color="#3E7662" label="2. Possibly related" value="2"></v-radio>
                            <v-radio class="mb-6" color="#3E7662" label="3. Probably related" value="3"></v-radio>
                            <v-radio class="mb-6" color="#3E7662" label="4. Definitely related" value="4"></v-radio>
                            <v-radio color="#3E7662" label="5. Unknown" value="5"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>

                      <!-- Is the reaction expected ?-->
                      <v-layout style="margin-top: 100px;">
                        <v-flex class="text-start font-weight-bold">
                          <span>Is the reaction expected ?</span>
                        </v-flex>
                      </v-layout>
                      <v-layout class="ml-6 mt-4">
                        <v-flex>
                          <v-radio-group v-model="form.isReactionExpected" :readonly="$route.query.read == 1">
                            <v-radio class="mb-6" color="#3E7662" label="Expected" value="1"></v-radio>
                            <v-radio class="mb-6" color="#3E7662"
                              label="Unexpected (not mentioned in the protocol/Investigator Brochure)"
                              value="2"></v-radio>
                            <v-radio class="mb-6" color="#3E7662" label="Unable to determined" value="3"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>

                      <!-- Progression -->
                      <v-layout style="margin-top: 100px;">
                        <v-flex class="text-start font-weight-bold">
                          <span>Progression</span>
                        </v-flex>
                      </v-layout>
                      <v-layout class="ml-6 mt-4">
                        <v-flex>
                          <v-radio-group v-model="form.progression" row :readonly="$route.query.read == 1">
                            <v-radio style="padding-right: 50px" color="#3E7662" label="Resolved" value="1"></v-radio>
                            <v-radio style="padding-right: 50px" color="#3E7662" label="Ongoing" value="2"></v-radio>
                            <v-radio color="#3E7662" label="Unknown" value="3"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>

                      <!-- Other actions taken -->
                      <v-layout style="margin-top: 100px;">
                        <v-flex class="text-start font-weight-bold">
                          <span>Other actions taken</span>
                        </v-flex>
                      </v-layout>
                      <v-layout class="ml-6 mt-4">
                        <v-flex>
                          <v-radio-group v-model="form.otherAction" v-if="$route.query.read == 1" readonly>
                            <v-radio class="mb-6" color="#3E7662" label="No action required" value="1"></v-radio>
                            <v-radio class="mb-6" color="#3E7662" label="Protocal amendment" value="2"></v-radio>
                            <v-radio class="mb-4" color="#3E7662" label="Informed consent amendment"
                              value="3"></v-radio>
                            <v-row>
                              <v-col cols="auto">
                                <v-radio color="#3E7662" label="others" value="4"></v-radio>
                              </v-col>
                              <v-col style="flex: 1;padding-left: 0">ddddddddd
                                <v-text-field readonly :disabled="form.otherAction !== '4'" color="#3E7662"
                                  class="mt-n4" v-model="form.other" hide-details />
                              </v-col>
                            </v-row>
                          </v-radio-group>
                          <v-radio-group v-else v-model="form.otherAction">
                            <v-radio @click.native="clearRadio" class="mb-6" color="#3E7662" label="No action required"
                              value="1"></v-radio>
                            <v-radio @click.native="clearRadio" class="mb-6" color="#3E7662" label="Protocal amendment"
                              value="2"></v-radio>
                            <v-radio @click.native="clearRadio" class="mb-4" color="#3E7662"
                              label="Informed consent amendment" value="3"></v-radio>
                            <v-row>
                              <v-col cols="auto">
                                <v-radio color="#3E7662" label="others" value="4"></v-radio>
                              </v-col>
                              <v-col style="flex: 1;padding-left: 0">
                                <v-text-field :disabled="form.otherAction !== '4'" color="#3E7662" class="mt-n4"
                                  v-model="form.other" hide-details />
                              </v-col>
                            </v-row>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <!-- Comments -->
                  <v-layout pa-12>
                    <v-flex>
                      <v-layout>
                        <v-flex class="text-start mb-4 font-weight-bold">
                          <span>Comments</span>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex>
                          <textarea-form :readonly="$route.query.read == 1" :model="form.commentTextBox" hide-detail
                            @update-data="updateData('commentTextBox', $event)" />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <v-layout style="padding-right: 100px;padding-left: 100px;margin-top: 80px;padding-bottom: 50px">
                    <v-flex>
                      <!-- ผลการพิจารณา -->
                      <v-layout>
                        <v-flex class="text-start font-weight-bold">
                          <span>ผลการพิจารณา</span>
                        </v-flex>
                      </v-layout>
                      <v-layout class="ml-6 mt-4">
                        <v-flex>
                          <v-radio-group v-model="form.summary" :readonly="$route.query.read == 1">
                            <v-radio color="#3E7662" class="mb-6" label="รับทราบ" value="1"></v-radio>
                            <v-radio color="#3E7662" class="mb-6" label="รับทราบ และขอข้อมูลเพิ่มเติม หรือมีข้อแนะนำ"
                              value="2"></v-radio>
                            <v-radio color="#3E7662" label="นำเข้าพิจารณาในที่ประชุมคณะอนุกรรมการฯ เพื่อดำเนินการต่อไป"
                              value="3"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>

                      <!-- ผู้ประเมิน -->
                      <v-layout style="margin-top: 150px;">
                        <v-flex xs6 class="text-start">
                          <v-layout>
                            <v-flex xs3 mt-4 class="justify-end font-weight-bold d-flex align-center">
                              <span>ผู้ประเมิน ทบทวน</span>
                            </v-flex>
                            <v-flex xs6 class="text-start text-field-center">
                              <v-text-field :readonly="$route.query.read == 1" hide-details v-model="form.signature"
                                color="#3E7662" append-icon="edit" />
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs3></v-flex>
                            <v-flex xs6 class=" text-field-center">
                              <v-layout>
                                <v-flex mr-2 mt-5 shrink class="d-flex align-center">
                                  <span>(</span>
                                </v-flex>
                                <v-flex>
                                  <v-text-field :readonly="$route.query.read == 1" hide-details v-model="form.signature"
                                    color="#3E7662" />
                                </v-flex>
                                <v-flex ml-2 mt-5 shrink class="d-flex align-center">
                                  <span>)</span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-spacer></v-spacer>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6>
                          <v-layout>
                            <v-spacer></v-spacer>
                            <v-flex shrink mr-4 class="text-end font-weight-bold d-flex align-center">
                              <span>วันที่ทบทวน</span>
                            </v-flex>
                            <v-flex xs5 class="text-end">
                              <TextfieldForm v-if="$route.query.read == 1" hide-detail :model="dateChange2" readonly />
                              <DateInputForm v-else hide-detail :model="dateChange2"
                                @update-data="updateDate('date', $event)" />
                            </v-flex>
                            <v-spacer></v-spacer>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <v-layout style="margin-top: 100px" class="pl-12 pb-12">
                    <v-flex class="text-start font-weight-bold">
                      <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- Button Save -->
                <v-layout mt-8>
                  <v-flex mb-12 style="text-align: right;">
                    <v-layout>
                      <v-flex>
                        <v-btn style="color: #3E7662" class="mx-4" depressed color="#ffffff"
                          @click="$router.go(-1)">ย้อนกลับ</v-btn>
                        <v-btn depressed dark class="mx-4" color="#3E7662" @click="saveDraft">
                          <span>บันทึกข้อมูล</span>
                        </v-btn>
                        <v-btn depressed dark color="#3E7662" @click="save" v-if="$route.query.read == 0">
                          <span>บันทึกข้อมูลและส่งการประเมิน</span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-pageAndLine="fullpageAndLine">
        </loading>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../components/input/TextfieldForm";
import DateInputForm from "../../components/input/DateInputForm";
import TextareaForm from "../../components/input/TextareaForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
import { mapState } from "vuex";
import domtoimage from "dom-to-image";

export default {
  name: "FormRO07",
  components: {
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
    TextfieldFormAppend,
  },
  data: () => ({
    isLoading: false,
    fullpageAndLine: true,
    form: {
      researchID: "",
      researchCode: "",
      firstName: "",
      lastName: "",
      researchName: "",
      Sponsor: "",
      medicinalProduct: "",
      adverseEvent: "",
      SAEDate: "",
      eventReport: "",
      eventSeverity: "",
      eventCausality: "",
      isReactionExpected: "",
      progression: "",
      otherAction: "",
      other: "",
      commentTextBox: "",
      summary: "",
      signature: "",
      date: "",
      dateEventReport: "",
    },
    dateChange1: "",
    dateChange2: "",
    dateEventReport: "",
  }),
  created() {
    this.getRO07_1();
    this.form.researchCode = this.$route.query.researchCodeRo07;
    this.form.researchName = this.$route.query.researchName;
    if (this.$route.query.fname) this.form.firstName = this.$route.query.fname;
    else this.form.firstName = this.$route.query.firstName;
    if (this.$route.query.lname) this.form.lastName = this.$route.query.lname;
    else this.form.lastName = this.$route.query.lastName;
    this.form.signature = this.user.thName;
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  methods: {
    async printPage() {
      this.printMode = true
      document.getElementsByClassName("print-form")[0].style.backgroundColor =
        "#fff";
      await document.querySelectorAll("button").forEach(function (element) {
        element.style.display = 'none'
      });
      await document.querySelectorAll(".v-icon").forEach(function (element) {
        element.style.display = 'none'
      });
      await document.getElementsByClassName("v-input--checkbox v-input--is-label-active").forEach(function (element) {
        element.innerHTML = '✓' + element.innerHTML
      })
      await document.getElementsByClassName("v-radio v-item--active").forEach(function (element) {
        element.innerHTML = '✓ ' + element.innerHTML
      })
      var node = document.getElementById("print");
      var self = this;
      domtoimage
        .toPng(node)
        .then(async function (dataUrl) {
          var img = new Image();
          img.src = dataUrl;
          var page = self.imageToPrint(img);

          var pageLink = "about:blank";
          var pwa = window.open(pageLink, "_new");
          pwa.document.open();
          pwa.document.write(page);
          pwa.document.close();
          self.printMode = false
          await document.querySelectorAll("button").forEach(function (element) {
            element.style.display = 'unset'
          });
          await document.getElementsByClassName("v-input--checkbox v-input--is-label-active").forEach(function (element) {
            element.innerHTML = element.innerHTML.replace('✓', '')
          })
          await document.getElementsByClassName("v-radio v-item--active").forEach(function (element) {
            element.innerHTML = element.innerHTML.replace('✓ ', '')
          })
          await document.querySelectorAll(".v-icon").forEach(function (element) {
            element.style.display = 'unset'
          });
          document
            .getElementsByClassName("print-form")[0]
            .removeAttribute("style");
        })
        .catch(function (error) {
          Swal.fire({
            title: "กรุณาเปิดการอนุญาต Pop Up!",
            description: "",
            icon: "error",
            confirmButtonColor: "#3E7662",
            cancelButtonColor: "rgb(189, 189, 189)",
            confirmButtonText: "ตกลง",
          }).then(async function () {

            await document.querySelectorAll("button").forEach(function (element) {
              element.style.display = 'unset'
            });
            await document.getElementsByClassName("v-input--checkbox v-input--is-label-active").forEach(function (element) {
              element.innerHTML = element.innerHTML.replace('✓', '')
            })
            await document.getElementsByClassName("v-radio v-item--active").forEach(function (element) {
              element.innerHTML = element.innerHTML.replace('✓ ', '')
            })
            await document.querySelectorAll(".v-icon").forEach(function (element) {
              element.style.display = 'unset'
            });
            document
              .getElementsByClassName("print-form")[0]
              .removeAttribute("style");
          })
        });
    },
    imageToPrint(source) {
      return (
        "<html><body onload='window.print()'><style>@media print {\n" +
        "  @page { margin: 0; }\n" +
        "  html, body {\n" +
        "    margin: 0;\n" +
        "    width: 210mm;\n" +
        "    height: 297mm;\n" +
        "  }\n" +
        "  img {\n" +
        "    margin-top: 10mm;\n" +
        "    margin-left: 20mm;\n" +
        "    width: 170mm;\n" +
        // "    height: 297mm;\n" +
        "  }\n" +
        "}</style>" +
        source.outerHTML +
        "</body></html>"
      );
    },
    updateData(name, val) {
      this.form[name] = val;
    },
    clearRadio() {
      this.form.other = "";
    },
    updateDate(name, val) {
      if (name === "SAEDate") {
        this.form.SAEDate = val.date;
        this.dateChange1 = this.changeDate(val.date);
      }
      if (name === "date") {
        this.form.date = val.date;
        this.dateChange2 = this.changeDate(val.date);
      }
      if (name === "dateEventReport") {
        this.form.dateEventReport = val.date;
        console.log("val", val);
        this.dateEventReport = this.changeDate(val.date);
      }
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    checkbox(name) {
      if (name === "checkTheCriteria11") {
        if (!this.form.checkTheCriteria11) {
          this.form.criteria11 = "";
        }
      }
      if (name === "hasFullBoardReview") {
        if (!this.form.hasFullBoardReview) {
          this.form.fullBoardReview = "";
        }
      }
    },
    save() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.form["researchID"] = this.$route.query.id;
          this.form["filter"] = this.$route.query.filter;
          this.form["rfID"] = this.$route.query.rfID;
          this.form["rfType"] = this.$route.query.rfType;
          this.$store
            .dispatch("FormRO/saveRO07_1", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.go(-1);
              });
              this.isLoading = false;
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
              // Swal.fire({
              //     title: 'Save failed!',
              //     text: 'บันทึกไม่สำเร็จ',
              //     icon: 'warning',
              // })
              // this.isLoading = false;
            });
        }
      });
    },
    saveDraft() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.form["researchID"] = this.$route.query.id;
          this.form["filter"] = this.$route.query.filter;
          this.form["rfID"] = this.$route.query.rfID;
          this.form["rfType"] = this.$route.query.rfType;
          this.$store
            .dispatch("FormRO/saveDraftRO07_1", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.go(-1);
              });
              this.isLoading = false;
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
              // Swal.fire({
              //     title: 'Save failed!',
              //     text: 'บันทึกไม่สำเร็จ',
              //     icon: 'warning',
              // })
              // this.isLoading = false;
            });
        }
      });
    },
    getRO07_1() {
      this.isLoading = true;
      let data = {
        rfID: this.$route.query.rfID,
        rfType: this.$route.query.rfType,
        id: this.$route.query.id,
      };
      this.$store
        .dispatch("FormRO/getRO07_1", data)
        .then((res) => {
          console.log("getRO07_1 : ", res);
          if (res !== "don't have ro07_1 yet") {
            console.log("WOW!", res);
            this.form.researchID = res.researchID;
            this.form.researchCode = res.researchCode;
            this.form.firstName = res.firstName;
            this.form.lastName = res.lastName;
            this.form.researchName = res.researchName;
            this.form.Sponsor = res.Sponsor;
            this.form.medicinalProduct = res.medicinalProduct;
            this.form.adverseEvent = res.adverseEvent;
            this.dateChange1 = res.SAEDate ? this.changeDate(res.SAEDate) : '';
            this.dateChange2 = res.date ? this.changeDate(res.date) : '';
            this.dateEventReport = res.dateEventReport ? this.changeDate(res.dateEventReport) : '';
            this.form.SAEDate = res.SAEDate;
            this.form.dateEventReport = res.dateEventReport;
            this.form.date = res.date;
            this.form.eventReport = res.eventReport ? res.eventReport.toString() : '';
            this.form.eventSeverity = res.eventSeverity ? res.eventSeverity.toString() : '';
            this.form.eventCausality = res.eventCausality ? res.eventCausality.toString() : '';
            this.form.isReactionExpected = res.isReactionExpected ? res.isReactionExpected.toString() : '';
            this.form.progression = res.progression ? res.progression.toString() : '';
            this.form.otherAction = res.otherAction ? res.otherAction.toString() : '';
            this.form.other = res.other;
            this.form.commentTextBox = res.commentTextBox;
            this.form.summary = res.summary.toString();
            this.form.signature = res.signature;
          } else {
            this.updateDate("date", {
              date: new Date().toISOString().substr(0, 10),
            });
          }

          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.table-ro4-1 {

  /*** Table Styles **/
  .table-style-ro04-1 {
    .v-input__slot {
      align-items: center;
      justify-content: center;
    }

    .table-fill-ro04-1 {
      background: white;
      border-radius: 3px;
      border-collapse: collapse;
      margin: auto;
      padding: 5px;
      width: 100%;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
      animation: float 5s infinite;
      /*border-bottom: 5px solid #544A44;*/
    }

    th {
      color: #ffffff;
      background: #3e7662;
      /*border-top:5px solid #544A44;*/
      border-right: 0.75px solid gray;
      font-weight: 700;
      padding: 15px;
      vertical-align: middle;
    }

    tr {
      border-top: 1px solid #544a44;
      border-bottom-: 1px solid #544a44;
    }

    th:first-child {
      border-top-left-radius: 3px;
    }

    th:last-child {
      border-top-right-radius: 3px;
      border-right: none;
    }

    tr:first-child {
      /*border-top: none;*/
    }

    tr:last-child {
      /*border-bottom:5px solid #544A44;*/
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 3px;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 3px;
    }

    td {
      background: #ffffff;
      padding: 10px 30px 10px 30px;
      text-align: left;
      vertical-align: middle;
      font-weight: 700;
      color: black;
      border-right: 0.5px solid gray;
      border-top: 0.5px solid gray;
    }

    td:last-child {
      border-right: 0px;
    }

    th.text-left {
      text-align: left;
    }

    th.text-center {
      text-align: center;
    }

    th.text-right {
      text-align: right;
    }

    td.text-left {
      text-align: left;
    }

    td.text-center {
      text-align: center;
    }

    td.text-right {
      text-align: right;
    }
  }
}

.text-field-color {

  .theme--light.v-input,
  .theme--light.v-input input,
  .theme--light.v-input textarea {
    color: #cc3d45;
  }
}

.text-field-margin {
  .v-text-field {
    padding: 0;
    margin: 0;
  }
}

.textAlignVer-ro05 {
  color: #544a44;
  transform-origin: 0 50%;
  transform: rotate(-90deg) translate(-50%, 50%);
  position: absolute;
  top: 0;
  bottom: 0;
  height: 2em;
  /* line-height of .wrapper div:first-child span */
  margin: auto;
  font-weight: bold;
  font-size: 1em;
  line-height: 2em;
  /* Copy to other locations */
  left: 15px;
}
</style>
